module.exports = __webpack_public_path__ + "img/Gem@2x.30a0a0ca.png";